import { iCategoryType } from "@/interfaces/categories";

/**
 * Angular controller that manages the edit category type modal.
 *
 * @param {angular.IScope} $scope
 * @param categorizables
 */
class EditCategoryTypeController {
    static $inject = [
        '$scope',
        '$uibModalInstance',
        'categorizables',
        'categoryTypeId',
        'CategoryTypesApi',
    ];

    protected $scope: any;
    protected $uibModalInstance: any;
    protected categorizables: any;
    protected categoryTypeId: null | number;
    protected categoryTypesApi: any;
    protected categoryType: any;
    protected closeModal: any;
    protected dismissModal: any;
    protected isSaving: boolean;
    protected isLoading: boolean;

    constructor(
        $scope,
        $uibModalInstance,
        categorizables,
        categoryTypeId,
        categoryTypesApi,
    ) {
        // cache arguments
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.categorizables = categorizables;
        this.categoryTypeId = categoryTypeId,
        this.categoryTypesApi = categoryTypesApi;

        // set properties
        this.categoryType = null;
        this.isSaving = false;
        this.isLoading = false;

        // set methods
        this.closeModal = $uibModalInstance.close;
        this.dismissModal = $uibModalInstance.dismiss;
        this.bootstrap = this.bootstrap.bind(this);
        this.fetchCategoryType = this.fetchCategoryType.bind(this);
        this.saveCategoryType = this.saveCategoryType.bind(this);

        this.bootstrap();
    }

    /**
     * Initialises the controller.
     *
     * @returns {Promise<void>}
     */
    async bootstrap(): Promise<void> {
        if (this.categoryTypeId) {
            this.isLoading = true;
            this.fetchCategoryType(this.categoryTypeId)
                .then(categoryType => {
                    this.categoryType = categoryType;
                    this.isLoading = false;
                    this.$scope.$apply();
                })
                .catch((error) => {
                    this.dismissModal();
                    throw error;
                });
        }
    }

    /**
     * Loads a category type from the API.
     *
     * @param {number} id
     * @returns {Promise<iCategoryType>}
     */
    fetchCategoryType(id: number): Promise<iCategoryType> {
        return new Promise((resolve, reject) => {
            this.categoryTypesApi.get(
                { id },
                resolve,
                (error: any) => {
                    reject(error);
                },
            );
        });
    }

    /**
     * Saves the category type to the server then closes the modal.
     *
     * @param {iCategoryType} categoryType
     * @returns {Promise<void>}
     */
    saveCategoryType(categoryType: iCategoryType): Promise<void> {
        return new Promise((resolve, reject) => {
            this.isSaving = true;
            const save = categoryType.id ? this.categoryTypesApi.put : this.categoryTypesApi.post;

            save(
                categoryType,
                (savedCategoryType: iCategoryType) => {
                    this.isSaving = false;
                    this.closeModal(savedCategoryType);
                    resolve();
                },
                (error: any) => {
                    this.isSaving = false;
                    reject(error);
                },
            );
        });
    }
}

angular.module('app')
    .controller('editCategoryTypeController', EditCategoryTypeController);
